var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9C9CAE",
    fillRule: "evenodd",
    d: "M11.04 32H5.02V17.37H0V11.7h5.02V7.51c0-2.4.71-4.27 2.14-5.62C8.5.63 10.28 0 12.52 0c1.25 0 2.74.07 4.48.2v5.09h-3.15c-1.87 0-2.8.83-2.8 2.48v3.92h5.75l-.74 5.68h-5.02V32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.b63e1a75b411d148f8071a60c7406877.svg";
export { ForwardRef as ReactComponent };